import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { DutyAssignment } from './DutyAssignment';
import { Pharmacy } from './Pharmacy';

export const DutyExchangeItem = types.compose(
  BaseEntity,
  types.model('DutyExchangeItem', {
    dutyExchangeItemId: types.identifierNumber,
    dutyExchangeId: types.integer,
    dutyAssignmentId: types.integer,
    senderId: types.integer,
    recipientId: types.integer,
    sender: Pharmacy,
    recipient: Pharmacy,
    dutyAssignment: DutyAssignment,
  }),
);
